import React from 'react';

const ClassIcon = ({
  width = 16,
  height = 16,
  color = 'white',
}: {
  width?: number | string;
  height?: number | string;
  color?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={color}
    >
      <path
        d="M6.05001 17.7754C5.71668 17.5921 5.45835 17.3462 5.27501 17.0379C5.09168 16.7296 5.00001 16.3837 5.00001 16.0004V11.2004L2.60001 9.87539C2.41668 9.77539 2.28335 9.65039 2.20001 9.50039C2.11668 9.35039 2.07501 9.18372 2.07501 9.00039C2.07501 8.81706 2.11668 8.65039 2.20001 8.50039C2.28335 8.35039 2.41668 8.22539 2.60001 8.12539L11.05 3.52539C11.2 3.44206 11.3542 3.37956 11.5125 3.33789C11.6708 3.29622 11.8333 3.27539 12 3.27539C12.1667 3.27539 12.3292 3.29622 12.4875 3.33789C12.6458 3.37956 12.8 3.44206 12.95 3.52539L22.475 8.72539C22.6417 8.80872 22.7708 8.92956 22.8625 9.08789C22.9542 9.24622 23 9.41706 23 9.60039V16.0004C23 16.2837 22.9042 16.5212 22.7125 16.7129C22.5208 16.9046 22.2833 17.0004 22 17.0004C21.7167 17.0004 21.4792 16.9046 21.2875 16.7129C21.0958 16.5212 21 16.2837 21 16.0004V10.1004L19 11.2004V16.0004C19 16.3837 18.9083 16.7296 18.725 17.0379C18.5417 17.3462 18.2833 17.5921 17.95 17.7754L12.95 20.4754C12.8 20.5587 12.6458 20.6212 12.4875 20.6629C12.3292 20.7046 12.1667 20.7254 12 20.7254C11.8333 20.7254 11.6708 20.7046 11.5125 20.6629C11.3542 20.6212 11.2 20.5587 11.05 20.4754L6.05001 17.7754ZM12 12.7004L18.85 9.00039L12 5.30039L5.15001 9.00039L12 12.7004ZM12 18.7254L17 16.0254V12.2504L12.975 14.4754C12.825 14.5587 12.6667 14.6212 12.5 14.6629C12.3333 14.7046 12.1667 14.7254 12 14.7254C11.8333 14.7254 11.6667 14.7046 11.5 14.6629C11.3333 14.6212 11.175 14.5587 11.025 14.4754L7.00001 12.2504V16.0254L12 18.7254Z"
        fill={color}
      />
    </svg>
  );
};
export const FilledClassIcon = ({
  width = 16,
  height = 16,
  color = 'white',
}: {
  width?: number | string;
  height?: number | string;
  color?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.9999 10.6669V6.73359L8.63324 9.65026C8.43324 9.76137 8.22213 9.81693 7.9999 9.81693C7.77768 9.81693 7.56657 9.76137 7.36657 9.65026L1.73324 6.58359C1.61101 6.51693 1.5249 6.43359 1.4749 6.33359C1.4249 6.23359 1.3999 6.12248 1.3999 6.00026C1.3999 5.87804 1.4249 5.76693 1.4749 5.66693C1.5249 5.56693 1.61101 5.48359 1.73324 5.41693L7.36657 2.35026C7.46657 2.2947 7.56935 2.25304 7.6749 2.22526C7.78046 2.19748 7.88879 2.18359 7.9999 2.18359C8.11101 2.18359 8.21935 2.19748 8.3249 2.22526C8.43046 2.25304 8.53324 2.2947 8.63324 2.35026L14.9832 5.81693C15.0943 5.87248 15.1805 5.95304 15.2416 6.05859C15.3027 6.16415 15.3332 6.27804 15.3332 6.40026V10.6669C15.3332 10.8558 15.2693 11.0141 15.1416 11.1419C15.0138 11.2697 14.8555 11.3336 14.6666 11.3336C14.4777 11.3336 14.3193 11.2697 14.1916 11.1419C14.0638 11.0141 13.9999 10.8558 13.9999 10.6669ZM7.36657 13.6503L4.03324 11.8503C3.81101 11.728 3.63879 11.5614 3.51657 11.3503C3.39435 11.1391 3.33324 10.9114 3.33324 10.6669V8.13359L7.36657 10.3169C7.56657 10.428 7.77768 10.4836 7.9999 10.4836C8.22213 10.4836 8.43324 10.428 8.63324 10.3169L12.6666 8.13359V10.6669C12.6666 10.9114 12.6055 11.1391 12.4832 11.3503C12.361 11.5614 12.1888 11.728 11.9666 11.8503L8.63324 13.6503C8.53324 13.7058 8.43046 13.7475 8.3249 13.7753C8.21935 13.803 8.11101 13.8169 7.9999 13.8169C7.88879 13.8169 7.78046 13.803 7.6749 13.7753C7.56935 13.7475 7.46657 13.7058 7.36657 13.6503Z"
        fill={color}
      />
    </svg>
  );
};

export default ClassIcon;
